import { api } from '../lib/apiClient';
import { useRessource } from './useRessource';
import type { EtatCompteGmail } from '../types';

/**
 * L'etat du compte Gmail de l'utilisateur (0.73.0), charge quand
 * `actif` : les modales ne le demandent qu'ouvertes.
 */
export function useCompteGmail(actif: boolean) {
  return useRessource<EtatCompteGmail | null>(
    () => (actif ? api.get<EtatCompteGmail>('/api/auth/google/mail') : Promise.resolve(null)),
    [actif],
  );
}

/** Un compte connecte et utilisable : le brouillon peut partir. */
export function gmailPret(etat: EtatCompteGmail | null): boolean {
  return etat?.connexion !== null && etat?.connexion !== undefined && !etat.aReconnecter;
}
